export default __webpack_public_path__ + "static/media/explore-mobile-5.c32fcb9e.png";